module.exports = __webpack_public_path__ + "img/weixinzhifu.1bb0818d.png";